import {
  GET_REVENUES_FAIL,
  GET_REVENUES_SUCCESS,
  GET_REVENUE_DETAILS,
  GET_REVENUE_DETAILS_SUCCESS,
  GET_REVENUE_DETAILS_FAIL,
  GET_REVENUES,
  GET_ALL_TRANSACTIONS,
  GET_ALL_TRANSACTIONS_SUCCESS,
  GET_ALL_TRANSACTIONS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  revenues: {},
  revenueDetails: {},
  error: {},
  loading: false,
  allTransations: {},
}

const Revenues = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REVENUES:
    case GET_REVENUE_DETAILS:
      return {
        ...state,
        loading: true,
      }
    case GET_REVENUE_DETAILS_FAIL:
    case GET_REVENUES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_REVENUES_SUCCESS:
      return {
        ...state,
        revenues: action.payload,
        error: {},
        loading: false,
      }

    case GET_REVENUE_DETAILS_SUCCESS:
      return {
        ...state,
        revenueDetails: action.payload,
        error: {},
        loading: false,
      }

    // transactions

    case GET_ALL_TRANSACTIONS:
      return {
        ...state,
        loading: true,
      }
    case GET_ALL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        allTransations: action.payload,
      }

    case GET_ALL_TRANSACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Revenues
